import { isLocalEnv } from '@config/environment'
import type { RouteObject } from 'react-router'

import { lazy } from '../../../routes/lazy'
import { path } from '../../../routes/paths'
import { CanManageOrSupportOrgGuard } from '../components/CanManageOrSupportOrgGuard'
import { DealerRestrictedGuard } from '../components/DealerRestrictedGuard'
import OperationsLayout from './Operation/OperationLayout'

const localOnlyAnyoneRoutes: RouteObject[] = []

const localOnlyManagerRoutes: RouteObject[] = []

/** Routes that are hidden from dealer orgs and require manager/supporter permissions */
const dealerRestrictedRoutes: RouteObject[] = [
  {
    path: path.fields,
    Component: lazy(() => import('@features/operations/routes/Planning/Fields'))
  },
  {
    path: path.boundaries,
    Component: lazy(() => import('@features/operations/routes/Planning/Boundaries'))
  },
  {
    path: path.prescriptions,
    Component: lazy(() => import('@features/operations/routes/Planning/Prescriptions'))
  },
  {
    path: path.devices,
    Component: lazy(() => import('@features/operations/routes/Devices'))
  }
]

/** Whether a route path is one `DealerRestrictedGuard` wraps. */
export const isDealerRestrictedPath = (routePath: string): boolean =>
  dealerRestrictedRoutes.some((route) => route.path === routePath)

const managerRoutes: RouteObject[] = [
  {
    path: path.members,
    Component: lazy(() => import('@features/operations/routes/Members'))
  },
  {
    path: path.dataSharing,
    Component: lazy(() => import('@features/operations/routes/DataSharing'))
  },
  {
    path: path.billing,
    Component: lazy(() => import('@features/operations/routes/Billing'))
  }
]

const anyoneRoutes: RouteObject[] = [
  {
    path: path.fieldUpdate,
    Component: lazy(() => import('@features/operations/routes/DataManagment/Stream'))
  },
  {
    index: true,
    Component: lazy(() => import('@features/operations/routes/Operation'))
  },
  {
    path: path.softwareDownloads,
    Component: lazy(() => import('@features/operations/routes/SoftwareDownloads'))
  },
  {
    path: path.feedback,
    Component: lazy(() => import('@features/operations/routes/FeedbackForm'))
  },

  {
    path: path.applicationDataUpload,
    Component: lazy(() => import('@features/operations/routes/DataManagment/ApplicationDataUpload'))
  },
  {
    element: <CanManageOrSupportOrgGuard />,
    children: managerRoutes.concat(isLocalEnv() ? localOnlyManagerRoutes : [])
  },
  {
    element: <DealerRestrictedGuard />,
    children: dealerRestrictedRoutes
  },
  {
    path: path.archiveList,
    Component: lazy(() => import('@features/operations/routes/DataManagment/ArchivedStreams'))
  }
]

export const operationRoutes: RouteObject[] = [
  {
    element: <OperationsLayout />,
    children: anyoneRoutes.concat(isLocalEnv() ? localOnlyAnyoneRoutes : [])
  }
]
